import Image from 'next/image';
import useLocale from 'next-translate/useTranslation';

export const AnimationShowcaseSection = () => {
  const { t } = useLocale('ai-videos');

  const examples = [
    {
      sourceImage:
        'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/678f07fe-1955-4dfb-8299-07d69ab96cb4.png',
      animatedVideo:
        'https://videos.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/final_8e2c0d1e-26c9-4aaa-a8de-9ff825a0bcb0.mp4',
      title: 'Animate Portrait Photos',
      description:
        'Transform portrait photos into captivating animations that bring personality and emotion to life, perfect for social media and personal content.',
    },
    {
      sourceImage:
        'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c320f772-98e0-4629-8dd4-f5f43fefa9af.png',
      animatedVideo:
        'https://videos.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/final_4646b29d-6523-42f4-8994-ef83a3000d3b.mp4',
      title: 'Bring Memories to Life',
      description:
        'Add natural movement to couple photos and family portraits, creating heartwarming animations that capture the joy and connection between people.',
    },
    {
      sourceImage:
        'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f6ab6a4d-ed67-48a7-8133-6ce25b9b1a2c.png',
      animatedVideo:
        'https://videos.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/final_6309fccc-7722-4039-8a0d-a59732338916.mp4',
      title: 'Animate Still Images',
      description:
        'Add natural motion to any still image, bringing your photos to life with smooth, realistic movement that captures attention.',
    },
  ];

  return (
    <div className='bg-gray-100 px-5 py-20 dark:bg-slate-900'>
      <div className='mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8'>
        <h2 className='mx-auto mb-8 mt-2 max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent sm:text-4xl'>
          {t('Animate Photos to Make Them Move')}
        </h2>
        <p className='mx-auto mb-20 max-w-2xl text-lg text-gray-600 dark:text-slate-300'>
          {t(
            'Transform your static images into eye-catching animations that captivate viewers. Perfect for marketing and social media, animated content drives higher engagement and helps tell your story in a more compelling way. Our AI technology brings natural motion and life to any image, creating an emotional connection with your audience.'
          )}
        </p>
        <div className='mx-auto flex max-w-7xl flex-col gap-32'>
          {examples.map((example, index) => (
            <div key={index} className='space-y-8'>
              <div className='text-center'>
                <h3 className='mb-3 text-2xl font-bold text-gray-900 dark:text-white'>
                  {t(example.title)}
                </h3>
                <p className='mx-auto max-w-2xl text-gray-600 dark:text-slate-300'>
                  {t(example.description)}
                </p>
              </div>
              <div className='mx-auto flex flex-col items-center justify-center gap-8 md:flex-row'>
                <div className='relative'>
                  <img
                    alt='Static Image'
                    src={example.sourceImage}
                    className='w-[350px] rounded-lg shadow-lg'
                  />
                  <div className='absolute bottom-4 left-4 right-4 rounded-lg bg-black/70 p-3 text-center text-sm text-white'>
                    {t('Original Static Image')}
                  </div>
                </div>
                <div className='flex items-center justify-center'>
                  <Image
                    width={100}
                    height={100}
                    alt='arrow'
                    className='w-[60px] rotate-90 transform sm:w-[100px] md:rotate-0'
                    src='/images/arrow.png'
                  />
                </div>
                <div className='relative'>
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className='w-[450px] rounded-lg shadow-lg'
                    src={example.animatedVideo}
                  />
                  <div className='absolute bottom-4 left-4 right-4 rounded-lg bg-black/70 p-3 text-center text-sm text-white'>
                    {t('AI-Generated Animation')}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
